import generateUtilityClasses from '@mui/utils/generateUtilityClasses';
const boxClasses = generateUtilityClasses('MuiBox', ['root']);
export default boxClasses;


//////////////////
// WEBPACK FOOTER
// ../@mui/system/esm/Box/boxClasses.js
// module id = 371
// module chunks = 22